import SigliveServiceV1 from 'Service/sigliveServiceV1';

const patchRequestApproval = async (id, statusProgress) => {
  const { data } = await SigliveServiceV1({
    method: 'PATCH',
    url: `/request-approval/approval/${id}`,
    data: {
      statusProgress
    },
  });

  return data;
};

export default patchRequestApproval;
